import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.genericFullWidthImageWithImagePatternGridSection.scss';

const GenericFullWidthImageWithImagePatternGridSection = ({ data }) => {
    return (
        <div className="cp-imageWithGridPattern" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-imageWithGridPattern__inner l--centerAlign" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.genericFullWithImageWithPatternAndGridSectionBulletPointers &&
                    <div className="cp-imageWithGridPattern__bullets l--flex">
                        {data.genericFullWithImageWithPatternAndGridSectionBulletPointers.map((bulletPoints, index) => (
                            <span key={index}>{bulletPoints.teaser}</span>
                        ))}
                    </div>
                }
                {data.genericFullWithImageWithPatternAndGridSectionButton &&
                    <div className="l-relativeButton">
                        <a className="l-button" href={data.genericFullWithImageWithPatternAndGridSectionButton.url} target={data.genericFullWithImageWithPatternAndGridSectionButton.target}>{data.genericFullWithImageWithPatternAndGridSectionButton.title}</a>
                        <a className="l-button l-backgroundHover" href={data.genericFullWithImageWithPatternAndGridSectionButton.url} target={data.genericFullWithImageWithPatternAndGridSectionButton.target}>{data.genericFullWithImageWithPatternAndGridSectionButton.title}</a>
                    </div>
                }
                {data.genericFullWithImageWithPatternAndGridSectionImage &&
                    <div className={`cp-imageWithGridPattern__image l-pattern${data.genericFullWithImageWithPatternAndGridSectionBackgroundPattern}`}>
                        {data.genericFullWithImageWithPatternAndGridSectionImage &&
                            <GatsbyImage image={getImage(data.genericFullWithImageWithPatternAndGridSectionImage.gatsbyImage)} alt={data.genericFullWithImageWithPatternAndGridSectionImage.altText} />
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default GenericFullWidthImageWithImagePatternGridSection;